var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from 'react';
import { SplitFactory } from '@splitsoftware/splitio';
export var useSplitClientFactoryData = function (_a) {
    var flagUser = _a.flagUser, authorizationKey = _a.authorizationKey;
    var _b = __read(useState(null), 2), lastUpdate = _b[0], setLastUpdate = _b[1];
    var _c = __read(useState(null), 2), client = _c[0], setClient = _c[1];
    var _d = __read(useState(null), 2), factory = _d[0], setFactory = _d[1];
    var updateListener = function () {
        setLastUpdate(new Date());
    };
    useEffect(function () {
        // added to reset the context if the flagUser data changes
        if (lastUpdate) {
            setLastUpdate(null);
        }
        if (flagUser && authorizationKey) {
            var newFactory = SplitFactory({
                core: {
                    authorizationKey: authorizationKey,
                    key: flagUser.accountId
                        ? flagUser.accountId.toString()
                        : flagUser.email,
                    trafficType: 'account'
                },
                startup: {
                    readyTimeout: 1.5 // seconds
                }
            });
            var newClient = newFactory.client();
            setFactory(newFactory);
            setClient(newClient);
            newClient.on(newClient.Event.SDK_READY, updateListener);
            newClient.on(newClient.Event.SDK_UPDATE, updateListener);
        }
        return function () {
            if (client) {
                client.removeListener(client.Event.SDK_READY, updateListener);
                client.removeListener(client.Event.SDK_UPDATE, updateListener);
                client.destroy();
            }
        };
    }, [flagUser, authorizationKey]); // eslint-disable-line
    return { client: client, factory: factory, lastUpdate: lastUpdate };
};
//# sourceMappingURL=useSplitClientFactoryData.js.map